// Supplier statuses
export const SUPPLIER_STATUS_CREATED = "created";
export const SUPPLIER_STATUS_INVITED = "invited";
export const SUPPLIER_STATUS_ACTIVE = "active";
export const SUPPLIER_STATUS_INACTIVE = "inactive";
